import { PageHeader } from "@/components/shared";
import { AgentRegistrationForm } from "@/components/agent/AgentRegistrationForm";

export function AgentRegistrationPage() {
  return (
    <div>
      <PageHeader
        title="Agent Registration"
        description="Create your verified agent profile to start responding to owner requests."
      />
      <AgentRegistrationForm />
    </div>
  );
}
